/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react'
import * as yup from 'yup'

export const useYupValidationResolver = (
  validationSchema: yup.ObjectSchema<
    {
      [x: string]: any
    },
    yup.AnyObject,
    {
      [x: string]: any
    },
    ''
  >
) =>
  useCallback(
    async (data: any) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false
        })

        return {
          values,
          errors: {}
        }
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: any, currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message
              }
            }),
            {}
          )
        }
      }
    },
    [validationSchema]
  )
